// Models
import { UnitViewModel } from '../models/unit-view.model';

export namespace UnitActions {
	export class GetAll {
		static readonly type = '[Unit] Get Units';
		constructor(public data: { showSpinner?: boolean; showToast?: boolean } = { showSpinner: false, showToast: false }) {}
	}

	export class SetAll {
		static readonly type = '[Unit] Set Units';
		constructor(public units: UnitViewModel[]) {}
	}

	export class Update {
		static readonly type = '[Unit] Update Unit';
		constructor(public data: { unit: UnitViewModel; showSpinner?: boolean; showToast?: boolean } = { unit: null, showSpinner: false, showToast: false }) {}
	}

	export class Modify {
		static readonly type = '[Unit] Modify Unit';
		constructor(public unit: UnitViewModel) {}
	}

	export class UpdateSuccess {
		static readonly type = '[Unit] Update Unit Success';
		constructor(public string: UnitViewModel) {}
	}

	export class UpdateError {
		static readonly type = '[Unit] Update Unit Error';
	}

	export class Delete {
		static readonly type = '[String] Delete Unit';
		constructor(public data: { id: number; showSpinner?: boolean; showToast?: boolean } = { id: null, showSpinner: false, showToast: false }) {}
	}
}
